<template>
  <div>
    <van-list
      class="bg-list"
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || articleList.length > 0">
        <BgItem
          class="bg-item"
          v-for="item in articleList"
          :key="item.id"
          :title="item.goodsName"
          :industryOne="item.goodsAttributeVoList.industryLevelOne.fieldValue"
          :industryTwo="item.goodsAttributeVoList.industryLevelTwo.fieldValue"
          :cover="item.albumPics"
          :price="item.goodsPrice"
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="collect" v-else />
    </van-list>
  </div>
</template>

<script>
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  components: {
    BgItem,
    noneList,
  },
  data() {
    return {
      params: {
        pageNum: 0,
        pageSize: 20,
        beginDateTime: "",
      },
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNum += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.params.pageNum == 1) {
        this.params.beginDateTime = this.$global.transferDate(new Date());
      }
      const resp = await this.$apis.listServe.getReportCollectList(this.params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.data.length < 20;
        this.articleList.push(...resp.data.data);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.$router.push("/detail/report?id=" + id);
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-list {
  padding: 12px 12px 0;

  .list-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .bg-item {
      width: 170px;
      margin-bottom: 12px;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
